import Link from 'next/link';
import cn from 'classnames';

import { NoteIcon, AgreementIcon } from 'src/shared/icons';
import { Typography } from 'src/shared/ui/Typography';

import styles from './index.module.css';

type Props = {
  href: string;
  className?: string;
};

export const Logotype = ({ className, href }: Props) => (
  <Link href={href} className={cn(styles.component, styles.clickable, className)}>
    <NoteIcon />
    <div className={styles.inner}>
      <AgreementIcon />
      <Typography view="semibold_16">Рекрутинг &ldquo;Сервис согласий ПДн&rdquo;</Typography>
    </div>
  </Link>
);
